import React from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "5rem" }}>
      <Card sx={{ maxWidth: 400, textAlign: "center", padding: "2rem" }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            404 - Not Found
          </Typography>
          <Typography variant="body1" gutterBottom>
            The page you are looking for does not exist.
          </Typography>
          <Button
            variant="contained"
           
            onClick={() => navigate("/")}
             sx={{
                        padding: "10px 0",
                        borderRadius: "8px",
                        backgroundColor: "#219297",
                        color: "#ffffff",
                        fontWeight: "bold",
                      }}
          >
            Go Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
